function formRight () {
    const form = document.querySelector('.form-right');

    if(sessionStorage.getItem('form-right') === null) {
        sessionStorage.setItem('form-right', 'open');
    }
    if(sessionStorage.getItem('form-right') === 'open') {
        setTimeout(() => {
            form.classList.add('form-right-open');
        }, 9000);
    }

    const close = form.querySelector('.close');

    close.addEventListener('click', function (e) {
        e.preventDefault();
        sessionStorage.setItem('form-right', 'close');
        form.classList.remove('form-right-open');
    });
}
formRight ();